// @flow strict
import * as React from 'react'
import styles from './HeroHeader.module.scss'

export type Props = {
  title: string,
  subtitle?: string,
  strapline?: string,
}

const HeroHeader = ({ title, subtitle, strapline }: Props) => (
  <header className={styles.hero}>
    <div className={styles.titleWrapper}>
      <h1 className={styles.heroTitle}>
        <span>{`${title}${subtitle ? ' / ' : ''}`}</span>
        {subtitle && <span className={styles.highlight}>{subtitle}</span>}
      </h1>
      {strapline && <p className={styles.strapline}>{strapline}</p>}
    </div>
  </header>
)

export default HeroHeader
